import { authRoles } from '@/core'
import { RouteRecordRaw } from 'vue-router'

const { ADMIN, MANUFACTURE } = authRoles

const Customers = () =>
  import(/* webpackChunkName: "login-view" */ './views/pages/index.vue')

export const customersModuleRoutes: Array<RouteRecordRaw> = [
  {
    path: '/customers',
    name: 'customers',
    component: Customers,
    meta: {
      title: 'Clientes',
      auth: {
        roles: [ADMIN, MANUFACTURE],
        redirect: '/auth/login',
        notFoundRedirect: { name: '/404' },
        forbiddenRedirect: '/404',
      },
    },
  },
]
